import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { WALLETS_FEATURE_NAME, walletsReducer } from "./wallets.reducer";
import { WalletsEffects } from "./wallets.effects";

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(WALLETS_FEATURE_NAME, walletsReducer), EffectsModule.forFeature([WalletsEffects])],
})
export class StoreWalletsModule {}
